/**
 * Combat Model B: aggregate DPS under the hood.
 * Presentation (Model A deaths) is derived by the render layer from HP fraction.
 */
import { TICK_DT, UNIT_DPS, UNIT_HP } from "./constants.js";
export function createWaveState(def) {
    const hp = Math.max(0, def.hp);
    return {
        def,
        hp,
        maxHp: hp,
        inContact: false,
        cleared: hp <= 0,
    };
}
/** Friendly aggregate DPS: mecha or N * unit DPS. */
export function friendlyDps(n, mecha) {
    if (mecha)
        return mecha.dps;
    return Math.max(0, Math.floor(n)) * UNIT_DPS;
}
/**
 * Apply one tick of mutual aggregate damage while in contact.
 * Returns units lost (friendly N reduction) and whether wave cleared.
 */
export function resolveCombatTick(wave, n, mecha, dt = TICK_DT) {
    if (wave.cleared || !wave.inContact || wave.hp <= 0) {
        return {
            wave,
            nAfter: n,
            mechaHpAfter: mecha ? mecha.hp : null,
            unitsLost: 0,
            damageToEnemy: 0,
            damageToFriendly: 0,
        };
    }
    const dpsOut = friendlyDps(n, mecha);
    const damageToEnemy = dpsOut * dt;
    let hp = Math.max(0, wave.hp - damageToEnemy);
    const cleared = hp <= 0;
    if (cleared)
        hp = 0;
    const damageToFriendly = wave.def.dps * dt;
    let nAfter = n;
    let mechaHpAfter = mecha ? mecha.hp : null;
    let unitsLost = 0;
    if (mecha) {
        mechaHpAfter = Math.max(0, mecha.hp - damageToFriendly);
    }
    else {
        // Convert incoming damage into unit losses via UNIT_HP.
        const loss = damageToFriendly / UNIT_HP;
        // Accumulate fractional losses via floor of remaining "injury" is simplified:
        // use probabilistic-free deterministic floor of cumulative — here per-tick floor.
        unitsLost = Math.floor(loss);
        // Partial: if loss < 1, use fractional bank via rounding at 0.5+ for feel.
        if (unitsLost === 0 && loss >= 0.5)
            unitsLost = 1;
        nAfter = Math.max(0, Math.floor(n) - unitsLost);
    }
    const next = {
        def: wave.def,
        hp,
        maxHp: wave.maxHp,
        inContact: !cleared && wave.inContact,
        cleared,
    };
    return {
        wave: next,
        nAfter,
        mechaHpAfter,
        unitsLost,
        damageToEnemy,
        damageToFriendly,
    };
}
/**
 * Contact if player pathZ is within wave.z ± halfLength.
 */
export function isInWaveContact(pathZ, wave, halfLength = 2.5) {
    const h = wave.contactHalfLength ?? halfLength;
    return Math.abs(pathZ - wave.z) <= h;
}
export { UNIT_DPS, UNIT_HP };
//# sourceMappingURL=combat.js.map